import * as auth from './auth.json';
import * as common from './common.json';
import * as financeApp from './financeApp.json';
import * as genericReports from './genericReports.json';
import * as hospital from './hospital.json';
import * as hotlist from './hotlist.json';
import * as invoices from './invoices.json';
import * as lots from './lots.json';
import * as mortalityReport from './mortalityReport.json';
import * as realizer from './realizer.json';
import * as receiveCattle from './receiveCattle.json';
import * as shipCattle from './shipCattle.json';
import * as treatments from './treatments.json';
import * as userManagement from './userManagement.json';
import * as processingChargeout from './processingChargeout.json';
import * as health from './health.json';

const en = {
    auth,
    common,
    financeApp,
    genericReports,
    hospital,
    hotlist,
    invoices,
    lots,
    mortalityReport,
    realizer,
    receiveCattle,
    shipCattle,
    treatments,
    userManagement,
    processingChargeout,
    health,
};

export default en;
